import { Navigation24Regular } from '@fluentui/react-icons'
import { MinistryBrand } from './MinistryBrand'
import { InvestigationModeBadge } from './InvestigationModeBadge'
import { ConnectionStatus } from './ConnectionStatus'
import { UserProfile } from './UserProfile'
import type { ConnectionStatus as ConnectionStatusType } from '@/types/chat'
import styles from './TopHeader.module.css'

interface TopHeaderProps {
  connectionStatus: ConnectionStatusType
  onToggleMobileNav: () => void
}

export function TopHeader({ connectionStatus, onToggleMobileNav }: TopHeaderProps) {
  return (
    <header className={styles.root}>
      <div className={styles.left}>
        <button
          type="button"
          className={styles.menuButton}
          onClick={onToggleMobileNav}
          aria-label="Deschide meniul de navigare"
        >
          <Navigation24Regular />
        </button>
        <MinistryBrand variant="mark" />
        <div className={styles.divider} aria-hidden="true" />
        <div className={styles.titleBlock}>
          <span className={styles.ministryLabel}>Ministerul Fericirii și Ideilor Bune</span>
          <div className={styles.productRow}>
            <span className={styles.productName}>SOC-Copilot</span>
            <span className={styles.productTagline}>AI-assisted Security Operations</span>
          </div>
        </div>
      </div>
      <div className={styles.right}>
        <InvestigationModeBadge compact />
        <ConnectionStatus status={connectionStatus} />
        <UserProfile />
      </div>
    </header>
  )
}
